import { BulkAction } from './constants';

const ACTION_TEXT = {
  [BulkAction.Enable]: {
    status: 'active',
    effect: 'give those brands visibility to your data',
  },
  [BulkAction.Disable]: {
    status: 'inactive',
    effect: 'remove their visibility to your data',
  },
} as const;

export function getConfirmModalBodyText(action: BulkAction) {
  const { status, effect } = ACTION_TEXT[action];
  return `Setting the selected brands data sharing status to ${status} will ${effect}. Are you sure you want to set their data sharing status to ${status}?`;
}
